"use client";

import { c as _c } from "react/compiler-runtime";
import { shouldRedirectToWeb } from "@/utils/should-redirect";
import Link from "next/link";
import { useEffect, useState } from "react";
export default function NotFound() {
  const $ = _c(4);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const {
        pathname,
        search
      } = window.location;
      const needsRedirect = process.env.NODE_ENV === "production" && shouldRedirectToWeb(pathname);
      setShouldRedirect(needsRedirect);
      if (needsRedirect) {
        window.location.href = `https://web.settlin.in${pathname}${search}`;
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (shouldRedirect) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex min-h-screen items-center justify-center"><div className="text-center"><h1 className="text-2xl font-bold mb-4">Redirecting...</h1><p className="text-gray-600">Taking you to the link...</p></div></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex min-h-screen items-center justify-center bg-background"><div className="text-center px-4"><h1 className="text-6xl font-bold text-primary mb-4">404</h1><h2 className="text-2xl font-semibold mb-2">Page Not Found</h2><p className="text-muted-foreground mb-8">The page you are looking for does not exist.</p><Link href="/" className="inline-block px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors">Go to Homepage</Link></div></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}